export default __webpack_public_path__ + "static/media/stone_hover.b900921d.mp3";